import { makeStyles, fade } from '@material-ui/core/styles';
import colors from 'global/styles/colors';

const useStyles = makeStyles((theme) => ({
  ratingRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  col: {
    display: 'flex',
    flexDirection: (p) => (p.isMobile ? 'row' : 'column'),
    flex: '1 1 auto',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  ratingWrap: {
    display: 'flex',
    flexDirection: (p) => (p.isMobile ? 'column' : 'row'),
    width: '100%',
  },
  colMobile: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    height: '100%',
    width: 100,
    maxWidth: 20,
    minHeight: 30,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  textCol: {
    padding: theme.spacing(1),
  },
  textSmall: {
    fontSize: 12,
  },
  cpRow: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    pageBreakInside: 'avoid !important',
  },
  cpName: {
    width: (p) => (p.isMobile ? 100 : `calc(160px - ${theme.spacing(2)}px)`),
    minWidth: (p) => (p.isMobile ? 100 : `calc(160px - ${theme.spacing(2)}px)`),
    fontWeight: 600,
    fontSize: 12,
    display: 'flex',
    flexDirection: 'column',
  },
  cp_0: {
    backgroundColor: theme.palette.action.disabledBackground,
  },
  cp_1: {},
  hlRow: {
    backgroundColor: fade(theme.colors.danger, 0.15),
  },
}));

export default useStyles;
